var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-cbt-modal-component",
      attrs: { "data-grm-comp": "RoomCBTLogUser" },
    },
    [
      _c("div", { staticClass: "room-cbt-modal flex flex-col" }, [
        _c(
          "div",
          { staticClass: "room-cbt-header" },
          [
            _c("h6", [_vm._v("출제 이력 사용자 제출 결과")]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mt-6 min-h-0 flex-1 overflow-y-auto" },
          [
            _c("p", { staticClass: "text-2xl font-bold" }, [
              _vm._v(_vm._s(_vm.cbtLog.roomCbtTitle)),
            ]),
            _c("RoomCBTLogUserInfo", { staticClass: "mt-4" }),
            _c("RoomCBTLogUserResult", {
              staticClass: "mt-4",
              attrs: { roomCbtUser: _vm.roomCbtUser },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }